import React, { useEffect, useState } from 'react'
import Moment from 'react-moment'
import { EmptyData } from '../../commonLib/EmptyData'
import { getPageMargins } from '../../config/GlobalSettings'
import { GetEBoolName } from '../../enumCollections/EBool'
import { GetELedgerAssetSalaryName } from '../../enumCollections/ELedgerAssetSalary'
import { GetEPaymentStatusName } from '../../enumCollections/EPaymentStatus'
import { ContactViewS } from '../Global/Elements/ContactViewS'
import { ProcessingViewS } from '../Global/Elements/ProcessingViewS'
import { ProductionUnitViewS } from '../Global/Elements/ProductionUnitViewS'
import { ProductViewS } from '../Global/Elements/ProductViewS'
import { PrintBranding } from './PrintBranding'

export const ProcessingVoucherPrint = React.forwardRef((props, ref) => {
    const { paid, pending, processingVoucher, voucherPayment, voucherDetails } = props
    const [detailsCount, setDetailsCount] = useState({ fresh: 0, defective: 0, rejected: 0 });

    useEffect(() => {
        if (voucherDetails && voucherDetails.length > 0) {
            let cnt = { fresh: 0, defective: 0, rejected: 0 }
            voucherDetails.forEach(element => {
                cnt.fresh = cnt.fresh + element.productProcessingReceiving.freshQuantity
                cnt.defective = cnt.defective + element.productProcessingReceiving.defectiveQuantity
                cnt.rejected = cnt.rejected + element.productProcessingReceiving.rejectedQuantity
            });

            setDetailsCount({ ...cnt })
        }
    }, [voucherDetails]);

    return (
        <div ref={ref}>
            <style type="text/css">
                {getPageMargins()}
            </style>
            {
                processingVoucher &&
                <PrintBranding printName="Processing Voucher" id={processingVoucher.id} date={processingVoucher.voucherDate}>

                    {
                        processingVoucher &&
                        <div className="row">
                            <div className="col-xs-12">

                                <table style={{ width: "100%" }} className="table-bordered-dark">
                                    <tbody>
                                        <tr >
                                            <td>For Contact</td>
                                            <td>
                                                <ContactViewS item={processingVoucher.contact} uid={"CXV1"} />
                                            </td>
                                        </tr>
                                        <tr >
                                            <td>Phone</td>
                                            <td>{processingVoucher.contact.phone}</td>
                                        </tr>
                                        <tr >
                                            <td>Address</td>
                                            <td>{processingVoucher.contact.address}</td>
                                        </tr>
                                        <tr >
                                            <td>Email</td>
                                            <td>{processingVoucher.contact.email ? processingVoucher.contact.email : "NA"}</td>
                                        </tr>
                                        <tr >
                                            <td>Quantity</td>
                                            <td>
                                                Fresh: <b>{Number(detailsCount.fresh).toFixed(2)}</b>
                                                &nbsp;&nbsp;Defective: <b>{Number(detailsCount.defective).toFixed(2)}</b>
                                                &nbsp;&nbsp;Rejected: <b>{Number(detailsCount.rejected).toFixed(2)}</b>
                                                &nbsp;&nbsp;Total: <b>{Number(detailsCount.fresh + detailsCount.defective + detailsCount.rejected).toFixed(2)}</b>
                                            </td>
                                        </tr>
                                        <tr >
                                            <td>Details</td>
                                            <td>{processingVoucher.linkedDetails}</td>
                                        </tr>
                                        <tr >
                                            <td>Amount</td>
                                            <td><b>{Number(processingVoucher.totalAmount).toFixed(2)}</b></td>
                                        </tr>
                                        <tr >
                                            <td><b>Voucher Balance</b></td>
                                            <td><span>Paid: <b>{Number(paid).toFixed(2)}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pending: <b>{Number(pending).toFixed(2)}</b> </span></td>
                                        </tr>
                                        <tr >
                                            <td>Note</td>
                                            <td>{processingVoucher.note ? processingVoucher.note : "NA"}</td>
                                        </tr>
                                        <tr >
                                            <td>Status</td>
                                            <td>{GetEPaymentStatusName(processingVoucher.paymentStatus)}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    }
                    <br />

                    <div className="row">
                        <div className="col-xs-12">
                            <h5 className="text-center">Payments</h5>
                            {voucherPayment && voucherPayment.length > 0 ?
                                <table style={{ width: "100%" }} className="table-bordered-dark">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>By</th>
                                            <th>Details</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {voucherPayment.map((item, index) =>
                                            <tr key={item.Id}>
                                                <td>{index + 1}</td>
                                                <td><Moment format="DD-MMM-YYYY">{item.receivedDate}</Moment></td>
                                                <td><b>₹ {item.amount}</b></td>
                                                <td>{GetELedgerAssetSalaryName(parseInt(item.fromLedgerId))}</td>
                                                <td>{item.transactionDetails}</td>
                                                <td>{item.note}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                :
                                <EmptyData>
                                    No payment made.
                                    <br />
                                    <br />
                                </EmptyData>
                            }
                        </div>
                    </div>
                    <br />


                </PrintBranding>

            }
            <div style={{ pageBreakBefore: 'always' }}></div>
            {processingVoucher && voucherDetails && voucherDetails.length > 0 &&
                <PrintBranding printName="Processing Voucher Details" id={processingVoucher.id} date={processingVoucher.voucherDate}>
                    <div className="row">
                        <div className="col-xs-12">
                            {voucherDetails && voucherDetails.length > 0 ?
                                <table style={{ width: "100%" }} className="table-bordered-dark">
                                    <thead>
                                        <tr>
                                            <th>#Id</th>
                                            <th>On Date</th>
                                            <th>Processing</th>
                                            <th>Product</th>
                                            <th>Wage/unit</th>
                                            <th>Fresh</th>
                                            <th>Defective</th>
                                            <th>Rejected</th>
                                            <th>Production</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {voucherDetails.map((item, index) =>
                                            <tr key={item.id + "-" + index}>
                                                <td>{item.productProcessingReceiving.id}</td>
                                                <td><div style={{ width: "70px" }}><Moment format="DD-MMM-YYYY">{item.productProcessingReceiving.onDate}</Moment></div></td>
                                                <td>
                                                    <ProcessingViewS item={item.productProcessingReceiving.processing} />
                                                </td>

                                                <td>
                                                    <ProductViewS item={item.productProcessingReceiving.product} uid={"PP" + index} />
                                                </td>

                                                <td>₹{Number(item.productProcessingReceiving.processingWage.wage).toFixed(2)}</td>
                                                <td>{item.productProcessingReceiving.freshQuantity} {item.productProcessingReceiving.unit}</td>
                                                <td>{item.productProcessingReceiving.defectiveQuantity} {item.productProcessingReceiving.unit}</td>
                                                <td>{item.productProcessingReceiving.rejectedQuantity} {item.productProcessingReceiving.unit}</td>
                                                <td>
                                                    {item.productProcessingReceiving.isProductionUnit == 1 ? (item.productProcessingReceiving.productionUnit ?
                                                        <ProductionUnitViewS item={item.productProcessingReceiving.productionUnit} />
                                                        : "NA") : <span class="label label-sm label-danger">{GetEBoolName(item.productProcessingReceiving.isProductionUnit)}</span>}
                                                </td>
                                                <td><div style={{ width: "150px" }}>{item.productProcessingReceiving.note}</div></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                :
                                <EmptyData>
                                    No payment made.
                                    <br />
                                    <br />
                                </EmptyData>
                            }
                        </div>
                    </div>
                </PrintBranding>
            }
        </div >
    )
})
